export function External(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon / External">
          <g id="Icon">
            <path
              d="M24 1.60001C25.3255 1.60001 26.4 2.67452 26.4 4.00001C26.4 5.32549 25.3255 6.40001 24 6.40001H12C8.9072 6.40001 6.4 8.90721 6.4 12V36C6.4 39.0928 8.9072 41.6 12 41.6H36C39.0928 41.6 41.6 39.0928 41.6 36V24C41.6 22.6745 42.6745 21.6 44 21.6C45.3255 21.6 46.4 22.6745 46.4 24V36C46.4 41.7438 41.7438 46.4 36 46.4H12C6.25624 46.4 1.6 41.7438 1.6 36V12C1.6 6.25624 6.25624 1.60001 12 1.60001H24Z"
              fill="currentColor"
            />
            <path
              d="M42 1.60001C44.43 1.60001 46.4 3.56995 46.4 6.00001V15C46.4 16.3255 45.3255 17.4 44 17.4C42.6745 17.4 41.6 16.3255 41.6 15V9.79412L25.6971 25.6971C24.7598 26.6343 23.2402 26.6343 22.3029 25.6971C21.3657 24.7598 21.3657 23.2402 22.3029 22.3029L38.2059 6.40001H33C31.7574 6.40001 30.7353 5.45561 30.6124 4.24539L30.6 4.00001C30.6 2.67452 31.6745 1.60001 33 1.60001H42Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}
